import { InjectionToken } from '@angular/core';

export const ENV_TOKEN = new InjectionToken<IEnvironment>('ANGULAR_STATIC_ENVIRONMENTS');
export const ENV_BUILD_TOKEN = new InjectionToken<IEnvironment>('BUILD_DYNAMIC_ENVIRONMENTS');
